module.exports = __webpack_public_path__ + "img/clinique.f0a2bced.jpg";